import styles from './Admin.module.css';

export function AdminRefunds() {
  return (
    <div className={styles.adminPage}>
      <header className={styles.pageHeader}>
        <div>
          <h1>Refund Management</h1>
          <p>Process and track customer refund requests.</p>
        </div>
      </header>

      <div className={styles.adminCard} style={{ textAlign: 'center', padding: '100px 20px' }}>
        <h2 style={{ marginBottom: '16px' }}>Refund management not configured yet.</h2>
        <p style={{ color: 'var(--text-3)', maxWidth: '500px', margin: '0 auto' }}>
          Automated refund processing requires additional Stripe webhook configuration for 'charge.refunded' and 'payment_intent.succeeded' events.
        </p>
      </div>
    </div>
  );
}
